import { useEffect, useRef, useState } from "react";
import { BACKEND } from "./api";

export function useEventSocket(eventId, onMessage) {
  const wsRef = useRef(null);
  const [connected, setConnected] = useState(false);
  const cbRef = useRef(onMessage);
  cbRef.current = onMessage;

  useEffect(() => {
    if (!eventId || !BACKEND) return;
    const wsUrl = `${BACKEND.replace(/^http/, "ws")}/api/ws/${eventId}`;
    let stop = false;
    let reconnectTimer = null;
    let openedOnce = false;
    const fireResync = () => {
      try { cbRef.current && cbRef.current({ type: "ws_reconnected" }); }
      catch (err) { console.debug("ws: resync handler failed", err); }
    };

    const connect = () => {
      if (stop) return;
      try {
        const ws = new WebSocket(wsUrl);
        wsRef.current = ws;
        ws.onopen = () => {
          setConnected(true);
          if (openedOnce) fireResync();
          openedOnce = true;
        };
        ws.onmessage = (e) => {
          try { cbRef.current && cbRef.current(JSON.parse(e.data)); }
          catch (err) { console.debug("ws: message handler failed", err); }
        };
        ws.onclose = () => {
          setConnected(false);
          if (!stop) reconnectTimer = setTimeout(connect, 1500);
        };
        ws.onerror = () => { try { ws.close(); } catch (err) { console.debug("ws: close after error failed", err); } };
      } catch (err) {
        console.debug("ws: connect failed, retrying", err);
        if (!stop) reconnectTimer = setTimeout(connect, 1500);
      }
    };
    connect();
    // Safety net: if the socket stays down, prompt subscribers to refetch.
    const pollTimer = setInterval(() => {
      if (!wsRef.current || wsRef.current.readyState !== 1) fireResync();
    }, 15000);
    return () => {
      stop = true;
      clearInterval(pollTimer);
      if (reconnectTimer) clearTimeout(reconnectTimer);
      try { wsRef.current && wsRef.current.close(); } catch (err) { console.debug("ws: cleanup close failed", err); }
    };
  }, [eventId]);

  return { connected };
}
